import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DomainAuthGuardGuard  {
  
  constructor(private router: Router) {}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    // Get the hostname (e.g., "e4suite.example.com")
    const host = window.location.hostname;
    // Split by "."
    const parts = host.split('.');
    // Check first part
    if (['e4suite', 'e4score-suite-stage'].includes(parts[0].toLowerCase())) {
      // Redirect to login
      this.router.navigate(['/login']);
      return false;
    }

    return true;
  }
  
}
